<div class="content right" ngDraggable [handle]="DragHandle" style="z-index: 999;">
  <!-- Close icon -->
  <div class="draggableArea" #DragHandle>
    <i class="fa fa-bars menu"></i>
    <span class="title">Drag & Drop Document using this header</span>
    <div class="closePreview" (click)="expandArea()" style="right: 35px;">
      <i class="fa fa-expand expand"></i>
    </div>
    <div class="closePreview" (click)="onCancel()">
      <i class="fa fa-close"></i>
    </div>
  </div>

  <div class="content-wrapper" [ngClass]="{'medium': size === PreviewSize.MEDIUM,
                  'large': size === PreviewSize.LARGE}">

    <div class="modal-header">
      <h4 class="modal-title pull-left mt-2">Engage File</h4>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <h5 class="text-center mb-0">You are about to Engage Report</h5>
          <p class="text-center">an Engagement Information will be sent to:</p>

          <div class="header-wrapper" *ngIf="getSigner(); let user">
            <div class="user">
              <ngx-avatar name="{{user.NAME}}" size="48"></ngx-avatar>
              <div class="user-name">{{user.NAME}}</div>
              <div class="user-email" *ngIf="user.EMAIL">
                <a href="mailto:{{user.EMAIL}}">{{user.EMAIL}}</a>
              </div>
              <div class="address-wrapper">
                <span class="label">Address:</span>
                <span class="address">{{user.getFullAddress()}}</span>
              </div>

              <div class="address-wrapper" *ngIf="user.ENG_ADDRESS">
                <span class="label">Engagement Letter Address:</span>
                <span class="address">{{user.ENG_ADDRESS}}</span>
              </div>
            </div>

            <div class="at" *ngIf="user.CLIENT">at</div>

            <div class="company">
              {{user?.CLIENT?.COMPANY_NAME}}
            </div>
          </div>

        </div>
      </div>

      <div class="row" id="ENGAGEMENT_EMAIL">

        <div class="col-12">
          <div class="subject">
            <label class="rbv-label">Subject:</label>
            <input type="text" name="mailSubject" class="form-control rounded-0" [(ngModel)]="htmlSubject">
          </div>

          <div class="row mt-2">
            <div class="col-md-6">
              <label class="rbv-label">CC:</label>
              <input-search #ccField [provider]="userProvider" placeholder="Select CC Recipients"
                [presetHeader]="'Client Users'" [multiple]="true" [typeEmail]="true"
                (multipleValueChanged)="ccChanged($event)" [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>

            <div class="col-md-6">
              <label class="rbv-label">BCC:</label>
              <input-search #bccField [provider]="userProvider" placeholder="Select BCC Recipients"
                [presetHeader]="'Client Users'" [multiple]="true" [typeEmail]="true"
                (multipleValueChanged)="bccChanged($event)" [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
          </div>

          <label style="margin-top: 10px;">Engagement Email:</label>
          <!-- <angular-editor [(ngModel)]="htmlContent" [config]="editorConfig"></angular-editor> -->
          <quill-editor [styles]="editorStyle" name="ENGAGEMENT_EMAIL" [(ngModel)]="htmlContent"
            [modules]="quillModules"></quill-editor>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="footer-wrapper">
        <div class="warnings">

          <div class="text-wrapper" *ngIf="!user.SIGNATURE">
            <fa name="fa fa-exclamation-triangle" style="color: orange; margin-left: 5px;"></fa>
            <span class="warning-text"> Current User has no Signature. Edit Signature in <a (click)="gotoProfile()"
                href="javaScript:void(0);">Profile</a></span>
          </div>

        </div>

        <div class="actions">
          <button class="btn btn-rbv default" (click)="onCancel()"
            [disabled]="isLoading || isLoadingPreview">Cancel</button>
          <button class="btn btn-rbv" (click)="onConfirm()" *ngIf="!isLoading"
            [disabled]="isLoadingPreview">Engage</button>
          <button class="btn btn-rbv" disabled *ngIf="isLoading">
            <span class="loading-icon-small"></span> Processing
          </button>
        </div>
      </div>
    </div>


  </div>
</div>